/**
 * Created by zhouchenwen on 2017/9/11.
 */
cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_demandapply_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      //初始化barcode wangyda
			common.initBarcodeModel(viewmodel);
			//============================================================barcode related
			//扫码
			viewmodel.get("barcode").on('enter', function (data) {
				//字段对照
				var fields = {
					mainid: 'demandapply',
					product: 'product',
					productcode: 'product_cCode',
					productname: 'product_cName',
					// productsku: 'productsku',
					// barcode: 'barcode',
					// batchno: 'batchno',
					// producedate: 'producedate',
					// invaliddate: 'invaliddate',
					// productskucode: 'productsku_cCode',
					// weight: 'weight',
					quantity: 'num',
					//改为要货单位
					// unit: 'iunitId',
					// unitname: 'iunitId_name',
					storeOrderUnitKey:'iunitId',
					storeOrderUnit:'iunitId_name'
				};
				return common.onBarCodeEnter(data, viewmodel, fields);

				// return common.onBarCodeEnter(data, viewmodel, rowObj, afterBarcodeEnter);
			});
      //============================================================barcode related
      
		/**
      viewmodel.on("modeChange", function (mode) {
        if (mode == "browse") {
          if (viewmodel.get("btnAddDetail")) {
            viewmodel.get("btnAddDetail").setVisible(false);
          }
		  // 浏览态不显示销量，库存量，在途量
		  viewmodel.get("demandapplydetails").setColumnState("saleQty","visible",false);
		  viewmodel.get("demandapplydetails").setColumnState("currentQty","visible",false);
		  viewmodel.get("demandapplydetails").setColumnState("innoticeQty","visible",false);
        } else {
          if (viewmodel.get("btnAddDetail")) {
            viewmodel.get("btnAddDetail").setVisible(true);
          }
		  viewmodel.get("demandapplydetails").setColumnState("saleQty","visible",true);
		  viewmodel.get("demandapplydetails").setColumnState("currentQty","visible",true);
		  viewmodel.get("demandapplydetails").setColumnState("innoticeQty","visible",true);
        }
      });*/

	  viewmodel.on("beforeSave",function(data){
		   var vouchDate = viewmodel.get("vouchdate").getValue();
		   var details = viewmodel.get("demandapplydetails").getData();		  
			   
		   for(var i = 0; i< details.length;i++){
			   if(vouchDate){   
				   vouchDate = vouchDate.substring(0,10);
				   var recieveDate = details[i]["recieveDate"];
				   if(recieveDate && recieveDate < vouchDate){
					   cb.utils.alert("第"+(i+1)+"行商品希望到货日期不能小于业务日期！");
					   return false;
				   }
			   }
			   var num = details[i]['num'];
			   if(num <= 0){
				   cb.utils.alert("第"+(i+1)+"行商品，要货数量必须大于0！");
				   return false;
			   }
		   }
		   
		   
		   return true;
	  });
      //向后台传递行号
       viewmodel.getGridModel().setState('orderField', 'rowno');
      // 保存前校验商品行数量必须大于0
      // var productNumRowModel = viewmodel.getGridModel().getEditRowModel().get('num');


      var productStyleRowModel = viewmodel.getGridModel().getEditRowModel().get('productStyle_cName');
      productStyleRowModel.on('afterValueChange', function (args) {
        var referGridModel = productStyleRowModel.getCache('vm').getGridModel();
        var selectedRows = referGridModel.getSelectedRows();
        if (selectedRows.length == 0) {
          var conditions = referGridModel.getState('queryParams').condition;
          var commonVOs = conditions.commonVOs;
          var keyFieldMap = productStyleRowModel.getState('bill2ReferKeyFieldMap');
          // 款式参照面板的过滤条件复制到表体行上
          var selectedRowIndex = viewmodel.get("demandapplydetails").getSelectedRowIndexes()[0];
          for (var i = 0; i < commonVOs.length; i++) {
            var commonVO = commonVOs[i];
            var value = commonVO.value1;
            var itemName = commonVO.itemName;
            for (var key in keyFieldMap) {
              var field = keyFieldMap[key];
              var newField = field.replace("!", ".");
              if (itemName == newField) {
                viewmodel.get("demandapplydetails").setCellValue(selectedRowIndex, key, value)
              }
            }
          }
        }
      });
      viewmodel.on("afterLoadData", function () {
        var mode = viewmodel.getParams().mode;
        //viewmodel.get("btnReFresh").setVisible(true);
        //viewmodel.get("btnReFresh").setDisabled(false);
        /**
		if (mode == "browse") {
          // 浏览态列表不需要显示库存量，在途量和销量
          viewmodel.get("demandapplydetails").setColumnState("saleQty", "visible", false);
          viewmodel.get("demandapplydetails").setColumnState("currentQty", "visible", false);
          viewmodel.get("demandapplydetails").setColumnState("innoticeQty", "visible", false);
        }*/
        // 浏览态+编辑态显示单据状态，新增态不显示
        if (mode == "browse")
          viewmodel.get("bizstatus").setVisible(true);
        else if (mode == "add")
          viewmodel.get("bizstatus").setVisible(false);
      }.bind(this));
      //仓库选定后，将仓库的所属组织赋值到出库组织，并且不允许出库组织修改
      /**
      viewmodel.get("outWarehouse_name").on("afterValueChange",function (data) {
        //修改了仓库，且不是删除
        if(data.value != ""){
          viewmodel.get("outWarehouseOrg_name").setReadOnly(true);
        }else{
          //仓库为空，出库组织节点可以修改
          viewmodel.get("outWarehouseOrg_name").setReadOnly(false);
        }
      });*/
      // 组织变化后，仓库清空
      viewmodel.get("outWarehouseOrg_name").on("afterValueChange", function (data) {
        viewmodel.get("outWarehouse").clear();
        viewmodel.get("outWarehouse_name").clear();
      });


      //新增商品到列表行，重新查询该商品的存量，销量和在途量
      viewmodel.get("demandapplydetails").on("afterCellValueChange",function (args) {
        console.log("")
      });
      viewmodel.getGridModel().getEditRowModel().get('product_cName').on('afterValueChange', function (args) {
        /**
         * 1、获取到新选中的商品后，去后台查询销量和库存量，之后手动更新列表对应的字段
         * 2、获取到新选中的商品后，去后台查询该商品启用了哪几个规格项
         * */
        let warehouseId = viewmodel.get("demandWarehouse").getValue();
        let productsArray = this.getProductsParam(args.value, 1);
        let productIds = this.getProductIds(args.value);
        if (warehouseId && productsArray)
          this.querySaleNumAndStock(productsArray, warehouseId, viewmodel);
      //  if (productIds && productIds.length > 0)
      //    this.queryUsedSpec(productIds, viewmodel);
        this.setRecieveDateFromLastRow(viewmodel, args.value);
      }.bind(this));

      //查询当前规格项下的所有规格值
      var specifications = new Array();
      for(let i = 1; i <= 10; i++){
        let freeName = "free"+i;
        let freeItem = viewmodel.get("demandapplydetails").get(freeName);
        if(freeItem){
          freeItem.on("beforeBrowse",function (data) {
            var condition = { "isExtend": true, simpleVOs: [] };
            condition.simpleVOs.push({
              field: 'freeId',
              op: 'eq',
              value1: i
            });
            data.context.setFilter(condition);
          }.bind(i));
        }
      }
      // viewmodel.get("demandapplydetails").get("iunitId_name").on("beforeBrowse",function (data) {
      //   var productId =  viewmodel.get("demandapplydetails");
      //   var condition = {"isExtend":true,simpleVOs:[]};
      //   condition.simpleVOs.push({
      //     field:"id",
      //     op:"eq",
      //     value1:productId
      //   });
      // });
      //列表行参照前事件
      viewmodel.get("demandapplydetails").on("beforeBrowse", function (data) {
        if (data) {
          let rowIndex = data.rowIndex;
          switch (data.cellName) {
            case "iunitId_name":
              //选择计量单位之前必须先选择商品
              let productId = viewmodel.get("demandapplydetails").getCellValue(rowIndex, "product");
              if (productId) {
                let condition = { "id": productId };
                data.context.setCondition(condition);
              } else {
                cb.utils.alert("请先选择商品！");
                return false;
              }
              break;
            case "free1":
            case "free2":
            case "free3":
            case "free4":
            case "free5":
            case "free6":
            case "free7":
            case "free8":
            case "free9":
            case "free10":
              productId = viewmodel.get("demandapplydetails").getCellValue(rowIndex, "product");
              if (productId) {
				let condition={"productId":productId,"free":data.cellName};
				data.context.setCondition(condition);
              } else {
                cb.utils.alert("请先选择商品！", "warning");
                return false;
              }
              break;
            case "product_cCode":
            // 商品参照:

            case "productStyle_cName":
              // 款式参照：必须先选择商品（金一特性）
              productId = viewmodel.get("demandapplydetails").getCellValue(rowIndex, "product");
              if (!productId) {
                cb.utils.alert("请先选择商品！", "warning");
                return false;
              }
              break;
          }
        }
      });
      //新增行前事件
      viewmodel.get("demandapplydetails").on("beforeInsertRowFromRefer", function (data) {
        let selectedRow = viewmodel.get("demandapplydetails").getSelectedRows()[0];
        if (selectedRow) {
          let row = data.row;
          let keys = Object.keys(selectedRow);
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if(!row[key])
              row[key] = selectedRow[key];
          }
        }
      });
      //要货仓库发生改变，同步修改库存量在途量
      viewmodel.get("demandWarehouse").on("afterValueChange", function (args) {
        let warehouseId = args.value.demandWarehouse;
        let products = viewmodel.get("demandapplyDetails").getRows();
        let productsArray = this.getProductsParam(products, 2);
        this.querySaleNumAndStock(warehouseId, products, viewmodel)
      }.bind(this));
      // 点击刷新按钮，更新商品销量，库存量，在途量
      // viewmodel.get("btnReFresh").on("click",function () {
      //   let warehouseId = viewmodel.get("demandWarehouse").getValue();
      //   let demandApplyDetails = viewmodel.get("demandapplydetails").getRows();
      //   let productsArray = this.getProductsParam(demandApplyDetails,2);
      //   this.querySaleNumAndStock(productsArray,warehouseId,viewmodel)
      // }.bind(this));
    },
    // 查询商品销量、库存量、在途量
    querySaleNumAndStock: function (productsArray, warehouseId, viewmodel) {
/*lihk     
	 var proxy = cb.rest.DynamicProxy.create({ ensure: { url: "/bill/ref/getSaleNumAndCurrentStock", method: "POST" } });
      var params = {
        products: productsArray,
        warehouseId: warehouseId
      }
      if (warehouseId && productsArray.length > 0) {
        cb.utils.loadingControl.start();
        proxy.ensure(params, function (err, result) {
          cb.utils.loadingControl.end();
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }
          let demandApplyDetails = viewmodel.get("demandapplydetails").getRows();
          for (let detail in demandApplyDetails) {
            let productIdofDetail = demandApplyDetails[detail].product;
            let flag = false;
            for (var item in result) {
              let productIdofItem = result[item].product;
              if (productIdofItem == productIdofDetail) {
                flag = true;
                if (result[item].saleQty)
                  viewmodel.get("demandapplydetails").setCellValue(detail, "saleQty", result[item].saleQty);
                else
                  viewmodel.get("demandapplydetails").setCellValue(detail, "saleQty", 0);
                if (result[item].currentQty)
                  viewmodel.get("demandapplydetails").setCellValue(detail, "currentQty", result[item].currentQty);
                else
                  viewmodel.get("demandapplydetails").setCellValue(detail, "currentQty", 0);
                if (result[item].innoticeQty)
                  viewmodel.get("demandapplydetails").setCellValue(detail, "innoticeQty", result[item].innoticeQty);
                else
                  viewmodel.get("demandapplydetails").setCellValue(detail, "innoticeQty", 0);
              }
            }
            if (!flag) {
              viewmodel.get("demandapplydetails").setCellValue(detail, "saleQty", 0);
              viewmodel.get("demandapplydetails").setCellValue(detail, "currentQty", 0);
              viewmodel.get("demandapplydetails").setCellValue(detail, "innoticeQty", 0);
            }

          }
        });
      } else if (!warehouseId) {
        cb.utils.alert("未确定要货仓库，无法查询存量！", 'error');
      } else if (productsArray.length <= 0) {
        cb.utils.alert("请先添加商品！", 'error');
      }
	  */
    },
    // 查询已经启用的规格项
    queryUsedSpec: function (productIds, viewmodel) {
      var querySpecProxy = cb.rest.DynamicProxy.create({ ensure: { url: "/mall/bill/ref/getProductSpec", method: "GET" } });
      var querySpecParams = {
        productIds: JSON.stringify(productIds),
      }
      cb.utils.loadingControl.start();
      querySpecProxy.ensure(querySpecParams, function (err, result) {
        // 拿到商品的启用规格项以后，禁用未启用的规格项单元格
        cb.utils.loadingControl.end();
        if (err) {
          cb.utils.alert(err.message, 'error');
          return;
        }
        let demandApplyDetails = viewmodel.get("demandapplydetails").getRows();
        for (let index in demandApplyDetails) {
          let productIdofDetails = demandApplyDetails[index].product;
          for (let k = 1; k <= 10; k++) {
            let flag = false;
            let freeName = "free" + k;
            for (let item in result) {
              let productIdofResult = result[item].productId;
              let cFreeId = result[item].cFreeid;
              if (productIdofDetails == productIdofResult && k == cFreeId) {
                flag = true;
                break;
              }
            }
            viewmodel.get("demandapplydetails").setCellState(parseInt(index), freeName, 'disabled', !flag);
          }
        }
      });
    },
    //构造查询参数：商品id+已经启用的规格项
    getProductsParam: function (products, type) {
      if (products) {
        let productArray = new Array();
        for (let i = 0; i < products.length; i++) {
          let product = new Object();
          if (type == 1 && products[i].id) {               // 从参照带过来的商品主键是ID
            product.product = products[i].id;
          } else if (type == 2 && products[i].product) {     // 列表中的商品主键是product
            product.product = products[i].product;
          } else {
            continue;
          }
          for (let j = 0; j <= 10; j++) {
            let freeItem = "free" + i;
            if (products[i][freeItem]) {
              product[freeItem] = products[i][freeItem];
            }
          }
          productArray.push(product);
        }
        return productArray;
      }
      return null;
    },
    // 从入参ages.value 中剥离出商品主键
    getProductIds: function (values) {
      if (values) {
        let productIds = new Array();
        for (let i = 0; i < values.length; i++) {
          productIds.push(values[i].id);
        }
        return productIds;
      }
      return null;
    },
    // 从最后一行商品行中带入希望到货日期
    setRecieveDateFromLastRow: function (viewmodel, values) {
      if (values) {
        var rows = viewmodel.get("demandapplydetails").getRows();
        var selectedRowIndex = viewmodel.get("demandapplydetails").getSelectedRowIndexes()[0];
        var length = values.length;
        var lastRowIndex = selectedRowIndex - length;
        var lastRecieveDate = viewmodel.get("demandapplydetails").getCellValue(lastRowIndex, "recieveDate");
        for (var i = lastRowIndex + 1; i < rows.length; i++) {
          //rows[i].recieveDate = lastRecieveDate;
          viewmodel.get("demandapplydetails").setCellValue(i, "recieveDate", lastRecieveDate);
        }
      }
    }
  }
  try {
    module.exports = ST_st_demandapply_VM_extend;
  } catch (error) {

  }
  return ST_st_demandapply_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_demandapply_VM.Extend.js